import { styled, Typography, type CSSObject } from '@mui/material';
import { Button, Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  contain: 'paint',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 0),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  display: 'flex',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  marginBottom: theme.spacing(1),
}));

export const StyledParagraph = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
  marginBottom: theme.spacing(2),
}));

export const StyledList = styled('ul')(({ theme }) => ({
  marginTop: theme.spacing(0),
  marginBottom: theme.spacing(0),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.aquamarineColors?.PLUS_2}, 0px 0px 6px 4px ${theme.palette.aquamarineColors?.PLUS_2} inset !important`,
  },
}));

export const StyledDashboardImage = styled('img')(({}) => ({
  width: '100%',
  height: 'auto',
  objectFit: 'contain',
}));
